<section id="wizard-step-content">
  <ng-content *ngIf="step.selected">
  </ng-content>
</section>
